import { makeGetApiRequest } from '@common/index'
import createDataContext from './createDataContext'
import axios from 'axios'

interface StateType {
    openMarketUnconfirmedParts: any,
    openMarketSoftConfirmedParts: any
}

interface ActionType {
    payload: any,
    type: string
}

const initialState: StateType = {
    openMarketUnconfirmedParts: {},
    openMarketSoftConfirmedParts: {}
}

const reducer = (state, action: ActionType) => {

    switch(action.type)
    {
        case 'getOpenMarketUnconfirmedParts': return { ...state, openMarketUnconfirmedParts: action.payload }

        case 'getOpenMarketSoftconfirmedParts': return { ...state, openMarketSoftConfirmedParts: action.payload }

        default: return state
    }

}

const downloadExcel = dispatch => {

    return async (url: string, callback?: (data) => void, err_callback?: (message) => void) => {

        try
        {

            const response = await makeGetApiRequest(url, {}, 'Keycloak-Authorization', 'Bearer', 'spares');

            const URL = response?.request?.responseURL
            const a = document.createElement("a")
            a.href = URL
            a.click();

            !!callback ? callback?.(url) : null

        } catch(e)
        {
            console.log('DOWNLOAD EXCEL ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }
    
}

const softConfirmPartsForOpenMarket = dispatch => {

    return async (variables, softConfirmPartsForOpenMarket, callback?: (data?) => void, err_callback?: (message) => void) => {

        try
        {

            const response = await softConfirmPartsForOpenMarket({ variables })

            !!callback ? callback?.(response.data?.assignVendorForHardConfirmationOpenMarket) : null

        } catch(e)
        {
            console.log('SOFT CONFIRM PARTS FOR OPEN MARKET ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const hardConfirmPartsForOpenMarket = dispatch => {

    return async (variables, hardConfirmPartsForOpenMarket, callback?: (data?) => void, err_callback?: (message) => void) => {

        try
        {

            const response = await hardConfirmPartsForOpenMarket({ variables })

            !!callback ? callback?.(response.data?.updatePurchaseListsForPurchaserAndVendor) : null

        } catch(e)
        {
            console.log('HARD CONFIRM PARTS FOR OPEN MARKET ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const getAllBrands = dispatch => {

    return async (variables, getAllBrands, callback?: (data?) => void, err_callback?: (message) => void) => {

        try
        {

            const response = await getAllBrands({ variables })

            !!callback ? callback?.(response.data?.getAllBrands) : null

        } catch(e)
        {
            console.log('GET ALL BRANDS ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const getAllVendors = dispatch => {

    return async (variables, getAllVendors, callback?: (data?) => void, err_callback?: (message) => void) => {

        try
        {

            const response = await getAllVendors({ variables })

            !!callback ? callback?.(response.data?.getAllVendors) : null

        } catch(e)
        {
            console.log('GET ALL VENDORS ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const getOpenMarketSoftconfirmedParts = dispatch => {

    return async (variables, getSoftconfirmedParts, callback?: (data?) => void, err_callback?: (message) => void) => {

        try
        {

            const response = await getSoftconfirmedParts({ variables })

            dispatch({ type: 'getOpenMarketSoftconfirmedParts', payload: response.data?.getAllSoftConfirmationEntries })
            
            !!callback ? callback?.(response.data?.getAllSoftConfirmationEntries) : null

        } catch(e)
        {
            console.log('GET OPEN MARKET SOFT CONFIRMED PARTS ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const getOpenMarketUnconfirmedParts = dispatch => {

    return async (variables, getUnconfirmedParts, callback?: (data?) => void, err_callback?: (message) => void) => {

        try
        {

            const response = await getUnconfirmedParts({ variables })

            dispatch({ type: 'getOpenMarketUnconfirmedParts', payload: response.data?.getAllPurchaseListsForVendor })

            !!callback ? callback?.(response.data?.getAllPurchaseListsForVendor) : null

        } catch(e)
        {
            console.log('GET OPEN MARKET UNCONFIRMED PARTS ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

export interface OpenMarketInterface {
    state: StateType,
    getOpenMarketUnconfirmedParts: (variables, getUnconfirmedParts, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    getOpenMarketSoftconfirmedParts: (variables, getSoftconfirmedParts, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    getAllVendors: (variables, getAllVendors, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    getAllBrands: (variables, getAllBrands, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    hardConfirmPartsForOpenMarket: (variables, hardConfirmPartsForOpenMarket, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    softConfirmPartsForOpenMarket: (variables, softConfirmPartsForOpenMarket, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    downloadExcel: (url: string, callback?: (data) => void, err_callback?: (message) => void) => Promise<void>
}

export const { Context:  OpenMarketContext, Provider: OpenMarketProvider } = createDataContext(reducer,
    { getOpenMarketUnconfirmedParts, getOpenMarketSoftconfirmedParts, getAllVendors, getAllBrands, hardConfirmPartsForOpenMarket, softConfirmPartsForOpenMarket, downloadExcel },
    initialState)
